import { Brand } from '@/components/Brand.tsx';
import { ApiRequestError } from '@/lib/api.ts';
import { VENUE_NAME } from '@okn/shared';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { adminLogin, setAdminSession } from './auth.ts';
import { Button } from './ui/Button.tsx';
import { Field, Input } from './ui/Field.tsx';

export function Login() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const nextRaw = params.get('next') ?? '/admin';
  // Only allow same-origin admin paths to avoid open-redirect.
  const next = nextRaw.startsWith('/admin') ? nextRaw : '/admin';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await adminLogin(email.trim(), password);
      setAdminSession({ token: res.token, expiresAt: res.expiresAt });
      navigate(next, { replace: true });
    } catch (err) {
      if (err instanceof ApiRequestError) setError(err.body.error.message);
      else setError('Giriş başarısız');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="relative flex min-h-dvh items-center justify-center px-6 py-16">
      {/* Spotlight glow behind the card */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse 60% 50% at 50% 38%, var(--accent-faint), transparent 70%)',
        }}
        aria-hidden="true"
      />
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: 'spring', stiffness: 120, damping: 18 }}
        className="modal-card relative w-full max-w-sm rounded-2xl px-8 py-10"
      >
        <Brand height={26} />
        <p className="mt-6 text-[11px] uppercase tracking-[0.2em] text-text-faint">{VENUE_NAME}</p>
        <h1 className="mt-2 font-display text-2xl font-medium tracking-tight">Yönetim Paneli</h1>
        <p className="mt-1 text-sm text-text-muted">Devam etmek için giriş yapın.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <Field label="E-posta">
            {(id) => (
              <Input
                id={id}
                type="email"
                inputMode="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@acarsanat.com"
                autoComplete="username"
              />
            )}
          </Field>
          <Field label="Şifre" error={error ?? undefined}>
            {(id) => (
              <Input
                id={id}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            )}
          </Field>
          <Button type="submit" size="lg" loading={busy} className="w-full">
            Giriş yap
          </Button>
        </form>
      </motion.div>
    </main>
  );
}
